// src/icons/CameraCapture.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function CameraCapture() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "68",
      height: "68",
      viewBox: "0 0 68 68",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.125 28.8176C23.125 27.1752 24.4564 25.8438 26.0989 25.8438H26.6401C27.871 25.8438 29.0515 25.3548 29.9219 24.4844C30.7923 23.614 31.9728 23.125 33.2037 23.125H34.7963C36.0272 23.125 37.2077 23.614 38.0781 24.4844C38.9485 25.3548 40.129 25.8438 41.3599 25.8438H41.9011C43.5436 25.8438 44.875 27.1752 44.875 28.8176V39.9036C44.875 41.6437 44.875 42.5138 44.5363 43.1785C44.2384 43.7631 43.7631 44.2384 43.1785 44.5363C42.5138 44.875 41.6437 44.875 39.9036 44.875H28.0964C26.3563 44.875 25.4862 44.875 24.8215 44.5363C24.2369 44.2384 23.7616 43.7631 23.4637 43.1785C23.125 42.5138 23.125 41.6437 23.125 39.9036V28.8176Z",
            stroke: "#999999",
            strokeWidth: "2.25"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M38.6607 34.7459C38.6607 37.32 36.574 39.4066 34 39.4066C31.426 39.4066 29.3393 37.32 29.3393 34.7459C29.3393 32.1719 31.426 30.0852 34 30.0852C36.574 30.0852 38.6607 32.1719 38.6607 34.7459Z",
            stroke: "#999999",
            strokeWidth: "2.25"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M2 18V13.2C2 9.27963 2 7.31945 2.76295 5.82207C3.43407 4.50493 4.50493 3.43407 5.82207 2.76296C7.31945 2 9.27963 2 13.2 2H18",
            stroke: "#999999",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M50 2L54.8 2C58.7204 2 60.6806 2 62.1779 2.76296C63.4951 3.43407 64.5659 4.50493 65.237 5.82207C66 7.31945 66 9.27963 66 13.2L66 18",
            stroke: "#999999",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M66 50L66 54.8C66 58.7204 66 60.6806 65.237 62.1779C64.5659 63.4951 63.4951 64.5659 62.1779 65.237C60.6806 66 58.7204 66 54.8 66L50 66",
            stroke: "#999999",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18 66L13.2 66C9.27963 66 7.31945 66 5.82207 65.237C4.50493 64.5659 3.43407 63.4951 2.76295 62.1779C2 60.6806 2 58.7204 2 54.8L2 50",
            stroke: "#999999",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}

export {
  CameraCapture
};
